export const PROPS_STEERING_DATA_GUID = "steeringDataGuid";
export const PROPS_NAME = "name";
export const PROPS_LOCATION = "location";
export const PROPS_FILE_NAME = "fileName";
export const PROPS_LAST_MODIFIED = "lastModified";
export const PROPS_EMBEDDING_STATUS = "embeddingStatus";
